import * as React from 'react'
import { Route, Switch } from 'react-router'
import DeliveryTracking from './containers/DeliveryTracking/DeliveryTracking'
import NotFound from './components/NotFound/NotFound'
import env from './lib/env'
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions'
import DeliveryRating from './containers/DeliveryRating/DeliveryRating';

export function getRouteWithEnv(route: string) {
  const e = env({ includeScrum: false })
  let prefix = ''
  if (e !== 'prod') {
    prefix += `/${e}`
  }

  return `${prefix}${route}`
}

export const TermsAndConditionsRoute = '/page/terms-and-conditions'

export const Routes: React.FunctionComponent = () => (
  <Switch>
    <Route exact path={getRouteWithEnv('/rating/:uuid')} component={DeliveryRating as any} />
    <Route exact path={getRouteWithEnv('/delivery/:uuid')} component={DeliveryTracking as any} />
    <Route exact path={getRouteWithEnv('/:uuid')} component={DeliveryTracking as any} />
    <Route exact path={getRouteWithEnv(TermsAndConditionsRoute)} component={TermsAndConditions as any} />
    <Route component={NotFound} />
  </Switch>
)
